import { Logo } from "@/components/shared/Logo";
import { Separator } from "@/components/ui/separator";
import { SidebarTrigger } from "@/components/ui/sidebar";
import { CreateMenu } from "./components/CreateMenu";
import { FrontEndUserMenu } from "./components/FrontEndUserMenu";
import { TopBarBreadcrumbs } from "./components/TopBarBreadcrumbs";

export function FrontEndTopBar() {
    return (
        <header className="bg-background sticky top-0 z-50 flex w-full items-center border-b">
            <div className="flex h-(--header-height) w-full items-center gap-2 px-4">
                <SidebarTrigger className="-ml-1" />
                <Separator orientation="vertical" className={"mr-2"} />
                <Logo style={{ width: 120 }} />

                <div className="hidden md:ml-2 md:flex">
                    <TopBarBreadcrumbs />
                </div>

                <div className="flex-1" />

                <CreateMenu />
                <FrontEndUserMenu />
            </div>
        </header>
    );
}
